export enum PaymentMethodCode {
  Blik = 'BLIK',
  PayNow = 'PAY_NOW',
  CreditCard = 'CREDIT_CARD',
  GooglePay = 'GOOGLE_PAY',
  PayU = 'PAYU',
  PayUInstallments = 'PAYU_INSTALLMENTS',
  PayURecursive = 'PAYU_RECURSIVE',
  CashOnDelivery = 'COD',
  BankTransfer = 'BANK_TRANSFER',
}
